import { render } from "./BlockEditorSingleIconPrefix.vue?vue&type=template&id=4df5c72e"
import script from "./BlockEditorSingleIconPrefix.vue?vue&type=script&lang=js"
export * from "./BlockEditorSingleIconPrefix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__